//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
import { useEffect, useState } from "react";

// Material ui Imports
import { SxProps } from "@mui/system";
import { CircularProgress, Grid, Typography, styled, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/SearchRounded";

// Custom components imports (and hooks and helpers)
import {
    formatDateTimePretty,
    VTButton,
    VTTextField,
    VTTypography,
    VTUserSelectTable,
} from "@virtus-tech-repository/virtus-tech-repository";

// Media imports

import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { DateCalendar, DateField, LocalizationProvider } from "@mui/x-date-pickers";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
    UserAttemptRowObjectType,
    VTPublishedArchiveTable,
} from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTableBasic";
import { useGetScenarioAttemptsQuery, useGetUserAttemptsQuery } from "../../services/tracking.service";
import { Params, useParams } from "react-router-dom";
import { setSelectedAttempt, setSelectedVersion } from "../../store/slices/current.slice";
import moment from "moment";
import { useGetScenarioOverviewQuery } from "../../services/scenario.service";
export const TemplateSceneImg = styled("img")(({ theme }) => ({
    borderRadius: "15px",
    height: "200px",
    width: "100%",
    objectFit: "cover",
    ":hover": {
        cursor: "pointer",
    },
}));

//---------------------------------------------------------------------------------------------------
// ## INTERFACES ##
interface IProps {
    sx?: SxProps;
}

export default function VTVersionSidePanel({ sx }: IProps) {
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##

    const dispatch = useAppDispatch();
    const theme = useTheme();

    const { selectedVersion } = useAppSelector((state) => state.currentReducer);
    const { scenarioId }: Readonly<Params<string>> = useParams();
    const [searchValue, setSearchValue] = useState<string>("");

    const [dateShow, setDateShow] = useState<boolean>(true);
    const [startDate, setStartDate] = useState<Dayjs>(dayjs("2022-04-17"));

    const [endDate, setEndDate] = useState<Dayjs>(dayjs("2022-04-17"));

    const { data: scenarioOverview } = useGetScenarioOverviewQuery(scenarioId ? scenarioId : "");

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="flex-start"
            sx={{
                height: "calc(100vh - 70px)",
                padding: "10px",
                width: "100%",
                paddingTop: "10px",
                overflow: "scroll",
                ...sx,
            }}
        >
            <Grid
                item
                xs={12}
                container
                justifyContent={"center"}
                alignContent={"flex-start"}
                // sx={{ height: "calc(100vh - 230px)", overflowY: "auto" }}
            >
                {scenarioOverview ? (
                    scenarioOverview!.published &&
                    scenarioOverview!.published?.publishedArchive &&
                    scenarioOverview!.published?.publishedArchive.length > 0 && (
                        <>
                            <VTPublishedArchiveTable
                                tableData={[

                                    ...scenarioOverview!.published?.publishedArchive.map((element: any) => {
                                        return {
                                            id: element.publishedId,
                                            publishedArchives: formatDateTimePretty(new Date(element.publishedDate)),
                                        };
                                    }),

                                ]}
                                onRowSelected={(e: any) => {
                                    dispatch(setSelectedVersion(e.id));
                                }}
                                selectedId={selectedVersion ? [selectedVersion] : undefined}
                            />
                        </>
                    )
                ) : (
                    <CircularProgress />
                )}
            </Grid>
        </Grid>
    );
}
